import React from 'react';
import { autoId, SignOut as SignOutCommon } from '@workday/upc-common';
import { AuthPage } from '../shared/auth-page/auth-page';
import { UpcFooter, UnauthenticatedHeader } from '../shared';
import { ID_UNAUTHENTICATED } from '../autoIds';
import { useDispatch } from 'react-redux';
import { loginActions } from '../slices/login.slice';
import { useTranslation } from 'react-i18next';

export function SignOut() {
    const dispatch = useDispatch();
    const { t } = useTranslation('auth');

    function onContinueClick() {
        dispatch(loginActions.logout());
    }

    const textProps = {
        header: t('SignOut.header'),
        description: t('SignOut.description'),
        signInButtonText: t('SignOut.signInButtonText')
    };

    return (
        <AuthPage header={<UnauthenticatedHeader />} footer={<UpcFooter isAuthenticated={false} />}>
            <SignOutCommon onSignInClick={onContinueClick} textProps={textProps} {...autoId(ID_UNAUTHENTICATED)} />
        </AuthPage>
    );
}
